const o = 5242880, t = 5242880, E = "Your file is too large. The maximum upload size is 5MB", e = "Unsupported file type", _ = "Exceeded the maximum number of uploads", a = "Exceeded the maximum upload size limit", A = "Sorry, your file must be larger than 0KB. Please remove and upload a larger file.", l = {
  OK: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500
}, s = {
  /**
   * Char seperator between the date different sections (day, month, year)
   */
  DATE_DIVIDER_CHAR: "/",
  /**
   * Date format for full mode
   */
  FULL_DATE_FORMAT: "DD/MM/YYYY",
  /**
   * Date format used by the Duet Datepicker - the format under the hood for our DatePicker component
   */
  DUET_DATE_FORMAT: "YYYY-MM-DD",
  /**
   * Date format for partial mode
   */
  MONTH_YEAR_FORMAT: "MM/YYYY",
  /**
   * Display date format in UX
   */
  DISPLAY_FORMAT: "DD MMMM YYYY"
}, T = 250, S = [
  {
    label: "ACT",
    value: "ACT"
  },
  {
    label: "NSW",
    value: "NSW"
  },
  {
    label: "NT",
    value: "NT"
  },
  {
    label: "QLD",
    value: "QLD"
  },
  {
    label: "SA",
    value: "SA"
  },
  {
    label: "TAS",
    value: "TAS"
  },
  {
    label: "VIC",
    value: "VIC"
  },
  {
    label: "WA",
    value: "WA"
  }
], D = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BLANK_FILE_ERROR_MESSAGE: A,
  Dates: s,
  EXCEEDING_FILE_SIZE_EROR_MESSAGE: E,
  EXCEEDING_MAX_TOTAL_FILE_SIZE_MESSAGE: a,
  EXCEEDING_MAX_UPLOADS_ERROR_MESSAGE: _,
  INPUT_DELAY: T,
  MAX_TOTAL_UPLOAD_FILE_SIZE: 5242880,
  MAX_UPLOAD_FILE_SIZE: 5242880,
  STATUS_CODES: l,
  UNSUPPORTED_FILE_TYPE_MESSAGE: e,
  stateOptions: S
}, Symbol.toStringTag, { value: "Module" }));
export {
  A as B,
  s as D,
  _ as E,
  T as I,
  o as M,
  l as S,
  e as U,
  t as a,
  a as b,
  E as c,
  D as d,
  S as s
};
